import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../config';
import './MatchesList.css';

function MatchesList() {
  const navigate = useNavigate();
  const userRole = localStorage.getItem('userRole');
  const [matches, setMatches] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMatches = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/wp-json/palpitex/v1/matches`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        setMatches(response.data);
        setError(null);
      } catch (error) {
        setError(error.response?.data?.message || 'Erro ao carregar jogos.');
      } finally {
        setLoading(false);
      }
    };

    fetchMatches();
  }, []);

  const handleAddMatch = () => {
    navigate('/add-match');
  };

  return (
    <div className="matches-container">
      <div className="matches-header">
        <h2>Lista de Jogos</h2>
        {userRole === 'administrator' && (
          <button className="add-button" onClick={handleAddMatch}>
            +
          </button>
        )}
      </div>
      {loading && <p>Carregando jogos...</p>}
      {error && <p className="error">{error}</p>}
      {!loading && !error && matches.length === 0 && (
        <p>Não há jogos cadastrados.</p>
      )}
      {!loading && !error && matches.length > 0 && (
        <div className="matches-list">
          {matches.map((match) => (
            <div key={match.id} className="match-item">
              <div className="match-teams">
                <div className="team team-left">
                  <img src={match.escudo_time1} alt={match.team1} className="team-logo" />
                  <span>{match.team1}</span>
                </div>
                <span className="vs">vs</span>
                <div className="team team-right">
                  <span>{match.team2}</span>
                  <img src={match.escudo_time2} alt={match.team2} className="team-logo" />
                </div>
              </div>
              <p className="match-date">Data: {match.date}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default MatchesList;